import Settings from './AccountsAndIds'
import ConnectionVerified from './ConnectionVerified'
import SelectAccounts from './SelectAccounts'
import SignIn from './SignIn'
import StepWithConnectionAndAccounts from './StepWithConnectionAndAccounts'
import FacebookSettings from './accounts-and-ids/FacebookSettings'
import GoogleAdwordsSettings from './accounts-and-ids/GoogleAdwordsSettings'
import GoogleAnalyticsSettings from './accounts-and-ids/GoogleAnalyticsSettings'

const SetupSteps = {
  ConnectionVerified,
  FacebookSettings,
  GoogleAdwordsSettings,
  GoogleAnalyticsSettings,
  SelectAccounts,
  Settings,
  SignIn,
  StepWithConnectionAndAccounts,
}

export default SetupSteps
